import { FunctionComponent, memo, useMemo } from 'react';
import { StoryCardContentMedia } from '../../../../services';
import { CardContainer } from '../CardContainer';
import { Content } from '../Content';
import { RightSideStoryCardProps } from '../RightSideStoryCard';

export const Media: FunctionComponent<RightSideStoryCardProps> = memo(({ card }) => {
  const { content } = card;

  const { headline, subHeadline, sourceName, text, textHTML } = content as StoryCardContentMedia;

  const hasContent = useMemo(() => {
    return [sourceName, headline, subHeadline, text, textHTML].some((item) => item?.length);
  }, [sourceName, headline, subHeadline, text, textHTML]);

  return (
    <CardContainer card={card}>
      {hasContent && (
        <Content
          source={sourceName}
          title={headline}
          subTitle={subHeadline}
          text={text}
          htmlText={textHTML}
        />
      )}
    </CardContainer>
  );
});
